import { create } from 'zustand';

const INITIAL_STATE = {

    description: '',

    motive: 0

};

export const useOccurrenceModalStore = create((set, get) => ({

    ...INITIAL_STATE,

    setDescription: (description) => {

        set(state => {

            if (state.description === description) {
                return state;
            }

            return { description };

        });

    },

    setMotive: (motive) => {

        set(state => {

            if (state.motive === motive) {
                return state;
            }

            return { motive };

        });

    },

    clear: () => {

        set(state => {

            if (
                state.description === INITIAL_STATE.description &&
                state.motive === INITIAL_STATE.motive
            ) {
                return state;
            }

            return {
                ...INITIAL_STATE
            };

        });

    },

    exportState: () => {

        const {
            description,
            motive
        } = get();

        return {
            description,
            motive
        };

    },

    importState: (state) => {

        if (!state) {
            return;
        }

        set({
            ...state
        });

    },

}));